module.exports = __webpack_public_path__ + "img/editar-morado.cf6a2551.svg";